import React from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Pagination } from '@material-ui/lab';
import { useJob } from '../../contexts/useJobs';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
    '&:focus': {
      outline: 'none',
    },
    '&:active': {
      outline: 'none',
    },
  },
}));

function Paginations(props) {
  const { searchQuery, filtros, jobs, Job, changedPage } = props;

  const classes = useStyles();

  const { changedPagination, pagination } = useJob();

  return (
    <Pagination
      className={classes.root}
      defaultPage={pagination}
      count={Math.ceil((searchQuery !== '' || filtros === true ? jobs : Job).length / 10)}
      variant="outlined"
      color="primary"
      onChange={(e, page) => {
        changedPagination(e, page);
        changedPage();
      }}
    />
  );
}

Paginations.propTypes = {
  searchQuery: PropTypes.string,
  filtros: PropTypes.bool,
  jobs: PropTypes.arrayOf(PropTypes.object),
  Job: PropTypes.arrayOf(PropTypes.object),
  changedPage: PropTypes.func,
};

Paginations.defaultProps = {
  searchQuery: PropTypes.string,
  filtros: PropTypes.bool,
  jobs: PropTypes.arrayOf(PropTypes.object),
  Job: PropTypes.arrayOf(PropTypes.object),
  changedPage: () => {},
};

export default Paginations;
